import React, { useState, useEffect } from 'react';
import 'react-datepicker/dist/react-datepicker.css';

import { Col, Form, Accordion, Card } from 'react-bootstrap';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import { useSelector, useDispatch } from 'react-redux';
import { isValid } from 'date-fns';
import AvalancheProgramDropdown from '@components/Common/DropDown/AvalanchePrograms';
import CardHeaderToggle from '@components/Common/Accordion/CardHeaderToggle';

import {
  currentEndDate,
  currentDisplayDay,
  currentDisplayDays,
  setEndDate,
  setDisplayDay,
  setProgram,
  fetchDashboardViews,
} from '@stores/avalancheDashboardViewPageSlice';

import { STATE_STATUS } from '@awp/constants';
import { Crud } from '@awp/shared/Crud';

const selectStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: 'white',
    borderColor: '#adb5bd',
    color: '#494949',
  }),
  input: (styles) => ({ ...styles }),
  placeholder: (styles) => ({ ...styles, color: '#494949' }),
  dropdownIndicator: (styles) => ({ ...styles, color: '#797979', '&:hover': { color: '#494949' } }),
};

const SetCurrentRegion = (rgId) => async (dispatch) => {
  console.log(rgId);
  dispatch(setProgram(rgId));
  dispatch(fetchDashboardViews());
};

const SetCurrentEndDate = (date) => async (dispatch) => {
  dispatch(setEndDate(Date.parse(date)));
};
const SetCurrentDisplayDay = (dn) => async (dispatch) => {
  dispatch(setDisplayDay(dn));
};
const AvalancheDashboardPageFilters = () => {
  const endDate = useSelector(currentEndDate);
  const loading = useSelector((state) => state.dashboardViewPage.status);
  const allDisplayDays = useSelector(currentDisplayDays);
  const selectedDisplayDay = useSelector(currentDisplayDay);

  const dispatch = useDispatch();

  const crud = new Crud('Avalanche Monitor');

  const changeOnDisplayDay = (selOption) => {
    dispatch(SetCurrentDisplayDay(selOption));
    dispatch(fetchDashboardViews());
  };

  return (
    <>
      <div className="d-flex">{crud.getHeader()}</div>
      <Accordion defaultActiveKey="0">
        <Card border="light" className="page-card">
          <CardHeaderToggle eventKey="0" as="h3" title={'Advanced Search'} />
          <Accordion.Collapse eventKey="0">
            <Card.Body>
              <div>
                <Form>
                  <Form.Row>
                    <Col lg={4} md={6} sm={3} className="mb-4">
                      <AvalancheProgramDropdown AreaChanged={SetCurrentRegion} styles={selectStyles} />
                    </Col>
                    <Col lg={3} md={6} sm={3} className="mb-3">
                      <Form.Label>
                        <b>Display Period</b>
                      </Form.Label>
                      <Select
                        options={allDisplayDays}
                        styles={selectStyles}
                        value={selectedDisplayDay}
                        //placeholder={'Please select'}
                        onChange={changeOnDisplayDay}
                        isLoading={loading == STATE_STATUS.LOADING}
                        isDisabled={loading == STATE_STATUS.LOADING}
                        //components={{ LoadingIndicator }}
                      />
                    </Col>
                    <Col lg={1} className=" d-none d-lg-block"></Col>

                    <Col lg={2} md={6} sm={3} className="mb-2">
                      <div>
                        <Form.Label>
                          <b>End Date</b>
                        </Form.Label>
                        <div style={{ width: '100%' }}>
                          <DatePicker
                            selected={new Date(endDate)}
                            className="form-control input-sm"
                            dateFormat={['yyyy-MM-dd HH:mm', 'yyyy-MM-dd', 'yyyyMMdd', 'yyyyMMddHHmm']}
                            showTimeSelect
                            closeOnSelect={true}
                            timeFormat="HH:mm"
                            timeIntervals={60}
                            disabled={loading == STATE_STATUS.LOADING || false}
                            onChange={(date) => {
                              if (isValid(date)) {
                                dispatch(SetCurrentEndDate(date));
                                setTimeout(() => {
                                  dispatch(fetchDashboardViews());
                                }, 2000);
                              }
                            }}
                          />
                        </div>
                      </div>
                    </Col>
                  </Form.Row>
                  <Col md={2} sm={2} className="d-block d-lg-none"></Col>
                </Form>
              </div>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </>
  );
};

export default AvalancheDashboardPageFilters;
